import { Link, useNavigate } from "react-router-dom";
import { ShieldCheck, SignOut } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export const AppShell = ({ children, breadcrumb }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-40 border-b border-slate-200 bg-white">
        <div className="mx-auto flex h-14 max-w-7xl items-center justify-between px-5 lg:px-8">
          <div className="flex items-center gap-5">
            <Link to="/" className="flex items-center gap-2" data-testid="app-brand-logo">
              <ShieldCheck size={22} weight="duotone" className="text-navy-800" />
              <span className="font-display text-sm font-extrabold text-navy-900">ProductSecurityReady</span>
            </Link>
            {breadcrumb && (
              <span className="hidden font-mono text-xs text-slate-500 sm:inline" data-testid="app-breadcrumb">
                / {breadcrumb}
              </span>
            )}
          </div>
          <div className="flex items-center gap-2">
            {user?.role === "admin" && (
              <Button variant="ghost" size="sm" onClick={() => navigate("/admin")} data-testid="app-admin-link">
                Admin
              </Button>
            )}
            <span className="hidden text-xs text-slate-500 sm:inline" data-testid="app-user-email">
              {user?.email}
            </span>
            <Button
              variant="outline"
              size="sm"
              onClick={async () => {
                await logout();
                navigate("/");
              }}
              data-testid="app-logout-button"
            >
              <SignOut size={15} className="mr-1.5" /> Log out
            </Button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-5 py-8 lg:px-8">{children}</main>
    </div>
  );
};
